import { ReactElement } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import ChartComponent from "./ChartComponent";
import { LargeShareholderTable } from './LargeShareholderTable'
import { StatusSharesTable } from './StatusSharesTable'
import { ChartAnnotation } from '@/components/elements/ChartAnnotation'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { AHeading } from '@/components/layouts/Ir/Heading'
import { AnotationText } from '@/components/layouts/Ir/Mpocket/AnotationText'

import type { StockSituation,StockSituationOwnership,stockSituationPrincipal } from '@/types/stockSituation'
// import { Paragraph } from '@/components/layouts/Ir/Paragraph'

// import { useMpocketScript } from '@/hooks/useMpocketScript'
type Props = {
  stockSituation: StockSituation[],
  stockSituationOwnership:StockSituationOwnership[],
  stockSituationPrincipal:stockSituationPrincipal[]
}
export const SituationPage = ({ stockSituation,stockSituationOwnership,stockSituationPrincipal }: Props) => {
  // useMpocketScript('//irpocket.com/141A/irpocket/ir-stock-situation.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/ir-stock-situation.js')

  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Stock Situation"
        subTitleText="株式の状況"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      {/* <Paragraph>株主総会後に公開予定です。</Paragraph> */}
      <AHeading>株式の状況</AHeading>
      <PublicationDate>({formatDate(stockSituation[0].statusSharesDate)}現在)</PublicationDate>
      <Spacer h={{ sp: 6, pc: 10 }} />
      <StatusSharesTable items={stockSituation} />
      <Spacer h={{ sp: 50, pc: 80 }} />
      <AnotationText dangerouslySetInnerHTML={{__html: stockSituation[0].statusSharesFootnotes}}></AnotationText>
      <Spacer h={{ sp: 70, pc: 100 }} />
      <AHeading>所有者別状況</AHeading>
      <PublicationDate>({formatDate(stockSituationOwnership[0].OwnershipBreakdownDate)}現在)</PublicationDate>
      <OwnerChart>
        {/* <CircleChart id="irp-highchart-situation2-container" /> */}
        <ChartComponent items={stockSituationOwnership} />
        <Legend id="irp-highlight-table-situation3" />
      </OwnerChart>
      <Spacer h={{ sp: 70, pc: 80 }} />
      <AHeading>大株主の状況</AHeading>
      <PublicationDate>({formatDate(stockSituationPrincipal[0].LargeShareholderDate)}現在)</PublicationDate>
      <Spacer h={{ sp: 6, pc: 10 }} />
      <LargeShareholderTable items={stockSituationPrincipal} />
      <AnotationText dangerouslySetInnerHTML={{__html: stockSituationPrincipal[0].principalShareholdersFootnotes}}></AnotationText>
    </Layout>
  )
}
const formatDate = (date: string | Date) => {
  return new Date(date).toLocaleDateString("zh-CN", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

SituationPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主、投資家向け情報', path: '/ir' },
    { name: '株式情報', path: '/ir/stock' },
    { name: '株式の状況', path: '' },
  ]

  return (
    <>
      <Head
        title="株式の状況"
        description="トライアルホールディングスの株式の発行数、株主数を掲載しています。"
        ogp={{ url: 'ir/stock/situation' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const OwnerChart = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 1047px) {
    flex-direction: column;
  }
`

const Legend = styled.div`
  tr::before {
    content: '';
    display: inline-block;
    height: 1rem;
    width: 1rem;
    vertical-align: -2px;
  }

  tr:first-of-type::before {
    background-color: ${theme.colors.chart.owner.bank};
  }

  tr:nth-of-type(2)::before {
    background-color: ${theme.colors.chart.owner.financialInstrumentsDealer};
  }

  tr:nth-of-type(3)::before {
    background-color: ${theme.colors.chart.owner.otherCorporation};
  }

  tr:nth-of-type(4)::before {
    background-color: ${theme.colors.chart.owner.foreignCorporation};
  }

  tr:nth-of-type(5)::before {
    background-color: ${theme.colors.chart.owner.treasuryStock};
  }

  tr:nth-of-type(6)::before {
    background-color: ${theme.colors.chart.owner.individual};
  }

  th {
    text-align: left;
    padding: 1rem;
    position: relative;

    ::after {
      content: ':';
      position: absolute;
      right: 0;
      display: inline-block;
    }
  }

  td:first-of-type {
    text-align: right;
    padding: 1rem;
  }
`

const PublicationDate = styled(ChartAnnotation)`
  text-align: right;
`
